
// src/web/components/group-member-icons.jsx

import React from 'react'
import connect from '../../connects/group-member-icons'
import animation from './animation-css'
import { translate } from 'react-i18next'
import Avatar from 'react-toolbox/lib/avatar'
import ToggleButton from './toggle-button.jsx'
import Tooltip from 'react-toolbox/lib/tooltip'
import successButtonTheme from './themes/success-button.css'
import newUserBadge from './themes/new-badge.css'
import {
  Button,
} from 'react-toolbox/lib/button'
import FontIcon from 'react-toolbox/lib/font_icon'
import buttonCss from 'react-toolbox/lib/button/theme.css'
import NewBadge from './new-badge.jsx'

const TooltipAvatar = Tooltip(Avatar)

function GroupMemberIcons(props) {
  const showUserTimeLine = (user)=> props.showUser(user)

  const {
    t,
    ui,
    user,
    users,
    group,
    updateUI,
    showUser,
    openGroupMembersPanel,
    usersAdminUrl,
    firstLogin,
    productTour,
  } = props

  if (!users || users.length == 0)
    return null
  
  const anim = animation(firstLogin && (!productTour || productTour.openGroupMemberPanel != 'hide'))
  const href = firstLogin && (!productTour || productTour.openGroupMemberPanel != 'hide') && usersAdminUrl || undefined

  return (
    <div>
      {user.trial && group.is_admin &&
        <Button onClick={openGroupMembersPanel} theme={successButtonTheme} raised
        href={href} target={href && '_blank'} rel={href && "noopener noreferrer"}
        style={{ margin: '0 5px'}}
        icon={<FontIcon value="person_add" className={buttonCss.icon}
          {...anim} />}
        label={<span {...anim}>{t('label:ユーザ追加')}</span>}/>
      }
      {!user.trial && group.is_admin && users.length > 1 &&
        <Button onClick={openGroupMembersPanel} floating mini
            theme={successButtonTheme} icon="person_add" />
      }
      {!user.trial && group.is_admin && users.length == 1 &&
        <Button onClick={openGroupMembersPanel} theme={successButtonTheme} raised
            href={href} target={href && '_blank'} rel={href && "noopener noreferrer"}
            style={{ margin: '0 5px'}}
            icon={<FontIcon value="person_add" className={buttonCss.icon}
              {...anim} />}
            label={<span {...anim}>{t('label:ユーザ追加')}</span>}/>
      }
      {(ui.showAll ? users : users.slice(0, 10)).map((user)=> {
          return (<div key={user.user_id} className={newUserBadge.box}>
            <TooltipAvatar key={user.user_id}
              style={{ cursor: 'pointer' }}
              tooltip={user.name}
              onClick={()=> showUserTimeLine(user)}
              image={user.icon_image.thumb_url} />
            <NewBadge created_at={user.created_at}/>
          </div>)})}
      {users.length > 10 &&
        <ToggleButton
            flag={!ui.showAll}
            onClick={()=> updateUI({ showAll: !ui.showAll })}
            style={{ marginLeft: 10 }}/>}
    </div>
  )
}

export default connect(GroupMemberIcons)
 


// WEBPACK FOOTER //
// ./src/web/components/group-member-icons.jsx